import React, { useEffect, useState } from 'react'
import Service from '../Networking/NetworkingUtils'
// import MaterialTable from 'material-table'
import { getCookie } from '../Utils/CookieHelper';
import { useSnackbar } from 'notistack';
import Blob from '../Blob';
// import { DropzoneArea } from 'material-ui-dropzone';
import { blobWriteString, generateRandomString } from '../Helper/BlobHelper';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Paper, Slide, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AddBoxIcon from '@mui/icons-material/AddBox';
import EditIcon from '@mui/icons-material/Edit';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { useDropzone } from 'react-dropzone';
import moment from 'moment';


var token = getCookie("bb_metaverse_token");
const user = JSON.parse(getCookie("bb_metaverse_user"));

const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ModelVersion = (props) => {

    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState([])
    const { enqueueSnackbar } = useSnackbar();
    const [openUpload, setOpenUpload] = useState(false)
    const [selectedRow, setSelectedRow] = useState(null)
    const [progress, setProgress] = React.useState(0)
    const [thumbnailUploadDialog, setThumbnailUploadDialog] = useState(false)
    const [loading, setLoading] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [columns] = useState([
        { title: 'Name', field: 'name', defaultSort: 'asc' },
        { title: 'Description', field: 'description' },
        // { title: 'Version Code', field: 'version_code' },
        { title: 'Date Created', field: 'date_created', type: 'date', render: rowData => moment(rowData.date_created).format('DD/MM/YYYY') },
        // { title: 'Is Active', field: 'is_active', type: 'boolean', lookup: { true: 'Active', false: 'InActive' } },
    ])
    const [dialogopen, setDialogopen] = useState(false)
    const [addData, setAddData] = useState({})
    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
        maxFiles: 1,
        maxSize: 10737418240,
    });
    const files = acceptedFiles.map(file => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
        </li>
    ));

    const getData = () => {
        Service.get(`/api/modular/object/version/get_modular_object_version/?modular_object=${props.model.id}`, {
            headers: {
                Authorization: "Token " + token,
            },
        }).then(res => {
            setData(res.data)
            setIsLoading(false)
        }).catch(error => {
            console.log(error)
            enqueueSnackbar('Something went wrong!', {
                variant: 'error'
            })
            setIsLoading(false)
        }
        )
    }

    const handleUploadDialog = () => {
        setSelectedRow(null)
        setThumbnailUploadDialog(false)
    }

    const postData = (data) => {
        setIsLoading(true)
        data.created_by = user.id
        data.thumbnail = null
        data.object_source = null
        data.modular_object = props.model.id
        Service.post('/api/modular/object/version/create_modular_object_version/', {
            headers: {
                Authorization: "Token " + token,
            },
            data: data,
        }).then(res => {
            getData()
            setAddData({})
            enqueueSnackbar('Model added Successfully!', {
                variant: 'success'
            })
        }).catch(error => {
            console.log(error)
            enqueueSnackbar('Something went wrong!', {
                variant: 'error'
            })
            setIsLoading(false)
        }
        )
    }

    useEffect(() => {
        console.log(props)
        getData()
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const editData = (data) => {
        if (!data.name || data.name.trim() === "") {
            enqueueSnackbar('Name is required!', {
                variant: 'warning'
            });
            return;
        } else {
            setIsLoading(true)
            data.created_by = user.id
            data.modular_object = props.model.id
            Service.patch('/api/modular/object/version/update_modular_objects_version/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: data
            })
                .then(res => {
                    setDialogopen(false)
                    setIsEdit(false)
                    setAddData({})
                    enqueueSnackbar('Model edited Successfully', {
                        variant: 'success'
                    });
                    getData()
                })
                .catch(error => {
                    console.log(error)
                    enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                });
        }
    }

    const UpdateBlob = (data, row) => {
        if (row && data.length > 0) {
            row.object_source = data.join()
            row.created_by = user.id
            row.id = selectedRow.id
            Service.patch('/api/modular/object/version/update_modular_objects_version/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: row
            }).then(res => {
                getData()
                enqueueSnackbar('Blob Uploaded Successfully!', {
                    variant: 'success'
                })
                setOpenUpload()
            }).catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                })
            })
        }
    }

    const handleClose = () => {
        setOpenUpload(false)
    }

    function UpdateThumbnail(thumbnail, rowData) {
        setIsLoading(true)
        rowData.thumbnail = thumbnail
        Service.patch('/api/modular/object/version/update_modular_objects_version/', {
            headers: {
                Authorization: "Token " + token,
            },
            data: rowData
        }).then(res => {
            enqueueSnackbar('Thumbnail added successfully!', {
                variant: 'success'
            })
            setSelectedRow(null)
            setThumbnailUploadDialog(false)
            getData()
        }).catch(error => {
            console.log(error);
            enqueueSnackbar('Something went wrong!', {
                variant: 'error'
            })
        })
    }

    const uploadFiles = async () => {
        const { BlobServiceClient } = require("@azure/storage-blob");
        window.Buffer = require("buffer").Buffer;

        const blobSasUrl = await blobWriteString({ token_type: 'write_only', container_name: 'model-lib' });
        const blobServiceClient = new BlobServiceClient(blobSasUrl);

        const containerName = "model-lib/BBVMODEL" + props.model?.id;

        const containerClient = blobServiceClient.getContainerClient(containerName);

        try {
            const promises = [];
            setLoading(true)
            for (const file of files) {
                var file_extension = file.key.split('.').pop()
                var file_name = generateRandomString() + '.' + file_extension
                const blockBlobClient = containerClient.getBlockBlobClient(file_name);
                promises.push(blockBlobClient.uploadData(file, {
                    onProgress: ev => {
                        setProgress((ev.loadedBytes / file.size) * 100)
                    }
                }));
            }
            await Promise.all(promises);
            setLoading(false)
            UpdateThumbnail(containerName + "/" + file_name, selectedRow)
            // this.props.updateBlob(file_name_array, this.props.version)
        }
        catch (error) {
            console.log(error.message);
            enqueueSnackbar('Something went wrong!', {
                variant: 'error'
            });
        }
    }

    const submit = (e) => {
        if (!addData.name || addData.name.trim() === "") {
            enqueueSnackbar('Name is required!', {
                variant: 'warning'
            });
            e.preventDefault();
            return;
        } else {
            postData(addData);
            setDialogopen(false);
        }
    }


    return (
        <div>
            {/* <MaterialTable
                title="Model Version"
                columns={[
                    { title: 'Name', field: 'name' , defaultSort: 'asc'},
                    { title: 'Description', field: 'description' },
                    { title: 'Version Code', field: 'version_code' },
                    { title: 'Date Created', field: 'date_created', type: 'date' },
                    { title: 'Is Active', field: 'is_active', type: 'boolean' },
                ]}
                isLoading={isLoading}
                data={data}
                editable={{
                    onRowAdd: newData =>
                        new Promise((resolve, reject) => {
                            postData(newData)
                            // setTimeout(() => {
                            resolve();
                            // }, 1000)
                        }),
                    onRowUpdate: (newData, oldData) =>
                        new Promise((resolve, reject) => {
                            // setTimeout(() => {
                            editData(newData)
                            resolve();
                            // }, 1000)
                        }),
                }}
                actions={[
                    rowData => ({
                        icon: 'upload',
                        tooltip: 'Upload',
                        disabled: rowData.object_source,
                        onClick: (row) => { setSelectedRow(rowData); console.log(rowData); console.log(row); setOpenUpload(true) }
                    }),
                    rowData => ({
                        icon: () => <CloudUploadIcon />,
                        tooltip: 'Upload Thumbnail',
                        // disabled: rowData.object_source,
                        onClick: (row) => { setThumbnailUploadDialog(true);setSelectedRow(rowData) }
                    })
                ]}
                options={{
                    padding: "dense",
                    paging: false,
                    filtering: true,
                    actionsColumnIndex: -1
                }}
            /> */}
            {isLoading ? <Box display={'flex'} justifyContent={'center'} alignItems={'center'} width='100%'><CircularProgress /></Box> :
                <TableContainer component={Paper}>
                    <Box display='flex' justifyContent='space-between' alignItems='center' width='100%' paddingX={2}>
                        <Typography variant="h5">Model Version</Typography>
                        <Box>
                            <Button onClick={() => setDialogopen(true)}><Tooltip title="Add"><AddBoxIcon /></Tooltip></Button>
                        </Box>
                    </Box>
                    <React.Fragment>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                    {columns && columns.map((column) => (
                                        <TableCell key={column.field}>{column.title}</TableCell>
                                    ))}
                                    <TableCell>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data && data.map((row) => (
                                    <React.Fragment key={row.id}>
                                        <TableRow>
                                            {columns && columns.map((column) => (
                                                <TableCell key={column.field}  >
                                                    {column.render ? column.render(row) : column.lookup ? column.lookup[row[column.field]] : row[column.field]}
                                                </TableCell>
                                            ))}
                                            <TableCell display='flex' justifyContent='space-evenly' alignItems='center'>
                                                <Tooltip title="Edit"><span><IconButton onClick={() => { setIsEdit(true); setAddData(row); setDialogopen(true) }}><EditIcon /></IconButton></span></Tooltip>
                                                <Tooltip title="Upload"><span><IconButton disabled={row.object_source} onClick={() => { setSelectedRow(row); console.log(row); setOpenUpload(true) }}><FileUploadIcon /></IconButton></span></Tooltip>
                                                <Tooltip title="Upload Thumbnail"><IconButton onClick={() => { setThumbnailUploadDialog(true); setSelectedRow(row) }}><CloudUploadIcon /></IconButton></Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    </React.Fragment>

                                ))}
                            </TableBody>
                        </Table>
                    </React.Fragment>
                </TableContainer>}
            <Dialog maxWidth="xs" fullWidth={true} open={dialogopen} onClose={() => setDialogopen(false)}>
                <DialogTitle marginTop="2px" spacing={2}>{isEdit ? "Edit Model Version" : "Add Model Version"}</DialogTitle>
                <DialogContent>
                    <Box sx={{ gap: "12px", display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: "column" }}>
                        <TextField variant='outlined' id="name" fullWidth label='Name' onChange={(e) => setAddData({ ...addData, name: e.target.value })} sx={{ marginTop: '10px' }} value={addData.name}></TextField>
                        <TextField variant='outlined' id="description" fullWidth label='Description' sx={{ marginTop: '5px' }} onChange={(e) => setAddData({ ...addData, description: e.target.value })} value={addData.description}></TextField>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" variant="text" onClick={() => setDialogopen(false)}>Cancel</Button>
                    <Button color="primary" variant="text" onClick={(e) => { isEdit ? editData(addData) : submit(e) }}>{isEdit ? "Edit" : "Add"}</Button>
                </DialogActions>
            </Dialog>
            <Dialog maxWidth="lg" fullWidth={true} open={openUpload}  >
                <DialogTitle marginTop="2px" spacing={2}>Upload Blob</DialogTitle>
                <DialogContent>
                    <Blob
                        obj={{ token_type: 'write_only', container_name: 'model-lib' }}
                        maxSize={false}
                        containerName={"model-lib/BBVMODEL" + props.model?.id}
                        fileName={props.model?.id + "_" + selectedRow?.id}
                        project={props.project}
                        asset={props.data}
                        version={selectedRow}
                        onClose={handleClose}
                        updateBlob={UpdateBlob}
                    />
                </DialogContent>
            </Dialog>
            <Dialog
                maxWidth="lg"
                fullWidth={true}
                TransitionComponent={Transition}
                open={thumbnailUploadDialog}
                onClose={handleUploadDialog}>
                <DialogTitle>Upload Thumbnail</DialogTitle>
                <DialogContent>
                    {/* <DropzoneArea
                        filesLimit={1}
                        maxFileSize={10737418240}
                        onChange={(files) => setSubmitDisabled(!(files.length > 0))}
                        onDrop={(files) => setFiles(files)}
                    /> */}
                    <section className="container">
                        <div {...getRootProps({ style: baseStyle })}>
                            <input {...getInputProps()} />
                            <p>Drag 'n' drop some files here, or click to select files</p>
                        </div>
                        <aside>
                            <h4>Files</h4>
                            <ul>{files}</ul>
                        </aside>
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button color='primary' variant='contained' onClick={() => handleUploadDialog()}>
                        close
                    </Button>
                    <Button disabled={files.length === 0} color='primary' variant='contained' onClick={() => uploadFiles()}>
                        submit
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog maxWidth="lg" fullWidth={true} open={loading}  >
                <DialogTitle marginTop="2px" spacing={2}>Uploading...</DialogTitle>
                <DialogContent>
                    <Box display="flex" alignItems="center">
                        <Box width="100%" mr={1}>
                            <LinearProgress variant="determinate" value={progress} />
                        </Box>
                        <Box minWidth={35}>
                            <Typography variant="body2" color="primary">{`${Math.round(
                                progress,
                            )}%`}</Typography>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>
        </div>
    )
}

// export default withSnackbar(ModelVersion)
export default ModelVersion;